module.exports = __webpack_public_path__ + "static/media/Handball-Icon-Desktop-Draft.43bf174d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Handball-Icon-Desktop-Draft.svg
// module id = 1194
// module chunks = 0